import React from 'react';
import styled from 'styled-components';
import { Color, Grid, Type } from '../../app/StyleGuide';
import { Button, OutlineButton } from '../../components/Buttons';
import { FeedbackCard } from './FeedbackCard';

const RecipientField = styled.div`
  margin-bottom: ${Grid._4};
`;

const RecipientLabel = styled.p`
  font-size: ${Type.Scale._1};
  font-weight: ${Type.Weight.semibold};
  color: ${Type.Color.medium};
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 ${Grid._2} 0;
`;

const RecipientValue = styled.p`
  display: inline-flex;
  align-items: baseline;
  gap: ${Grid._3};
  font-size: ${Type.Scale._3};
  color: ${Type.Color.dark};
  margin: 0;
`;

const RecipientValueIcon = styled.i`
  font-size: ${Type.Scale._2};
  color: ${Type.Color.medium};
`;

const CardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: ${Grid._4};
  gap: ${Grid._3};
  border-top: 1px solid ${Color.Gray._20};

  button {
    flex: 1;
  }
`;

export type FeedbackRecipientCardProps = {
  firstName: string;
  lastName: string;
  onResend: () => void;
  onReset: () => void;
  showActions?: boolean;
};

export default function FeedbackRecipientCard({
  firstName,
  lastName,
  onResend,
  onReset,
  showActions = true,
}: FeedbackRecipientCardProps) {
  return (
    <FeedbackCard>
      <RecipientField>
        <RecipientLabel>First Name</RecipientLabel>
        <RecipientValue style={{ fontWeight: Type.Weight.semibold }}>
          <RecipientValueIcon className="far fa-user" />
          {firstName || '—'}
        </RecipientValue>
      </RecipientField>
      <RecipientField>
        <RecipientLabel>Email</RecipientLabel>
        <RecipientValue>
          <RecipientValueIcon className="far fa-envelope" />
          {lastName || '—'}
        </RecipientValue>
      </RecipientField>
      {showActions && (
        <CardActions>
          <OutlineButton onClick={onReset}>
            <i className="fas fa-undo" />
            Reset
          </OutlineButton>
          <Button onClick={onResend}>
            <i className="fas fa-paper-plane" />
            Resend
          </Button>
        </CardActions>
      )}
    </FeedbackCard>
  );
}
